import {IconButton, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import moment from "moment";
import {CampaignStatusChips} from "./CampaignStatusChips";
import {extensionLabel} from "../hooks/useAmiExtensions";

const cellSx = {fontSize: 13, whiteSpace: "nowrap"};

// Stops the row click (open campaign) from firing
const stop = (handler) => (e) => {
  e.stopPropagation();
  handler();
};

export const CampaignRow = ({campaign, extension, onOpen, onEdit, onDelete}) => {
  return (
    <TableRow hover sx={{cursor: "pointer"}} onClick={() => onOpen(campaign)}>
      <TableCell>
        <Typography fontWeight={500} fontSize={14}>{campaign.name}</Typography>
        {campaign.description &&
          <Typography fontSize={12} color="text.secondary" noWrap sx={{maxWidth: 280}}>
            {campaign.description}
          </Typography>
        }
      </TableCell>
      <TableCell sx={cellSx}>{campaign.fromNumber || "-"}</TableCell>
      <TableCell sx={cellSx}>{extensionLabel(extension) || (campaign.extensionId ? "Unknown" : "-")}</TableCell>
      <TableCell sx={cellSx}>
        {moment(campaign.startDate).format("DD MMM YYYY")} – {moment(campaign.endDate).format("DD MMM YYYY")}
      </TableCell>
      <TableCell sx={cellSx}>{campaign.startTime} – {campaign.endTime}</TableCell>
      <TableCell sx={cellSx}>{campaign.maxAttempts}</TableCell>
      <TableCell sx={cellSx}>{campaign.totalPhoneNumbers ?? 0}</TableCell>
      <TableCell>
        <CampaignStatusChips statusCounts={campaign.statusCounts}/>
      </TableCell>
      <TableCell sx={cellSx}>
        {campaign.dateCreated ? moment(campaign.dateCreated).format("DD MMM YYYY HH:mm") : "-"}
      </TableCell>
      <TableCell padding={"checkbox"}>
        <Stack direction="row">
          <Tooltip title="Edit">
            <IconButton size="small" onClick={stop(() => onEdit(campaign))}>
              <HugeiconsIcon icon={PencilEdit01Icon} size={18}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" onClick={stop(() => onDelete(campaign))}>
              <HugeiconsIcon icon={Delete02Icon} size={18}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
